import { render, staticRenderFns } from "./basicsSetting.vue?vue&type=template&id=5f86a117&scoped=true"
import script from "./basicsSetting.vue?vue&type=script&lang=ts"
export * from "./basicsSetting.vue?vue&type=script&lang=ts"
import style0 from "./basicsSetting.vue?vue&type=style&index=0&id=5f86a117&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86a117",
  null
  
)

export default component.exports